import CategoriesList from './categorie-list';
export default CategoriesList;